var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader"},[_c('div',{staticClass:"loading-text"},[_vm._v(_vm._s(_vm.$t("poweredByFoyrLoader.loading")))]),_c('div',{staticClass:"powered-by-wrapper"},[_vm._v(" "+_vm._s(_vm.$t("poweredByFoyrLoader.poweredBy"))+" "),_c('img',{attrs:{"src":_vm.appImages['foyr-logo-with-name.png'],"alt":""}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }